const theme = {
  colors: {
    primaryColor: '#3498db',
    secondaryColor: '#2c3e50',
    accentColor: '#f39c12',
    lightColor: '#f8f9fa',
    darkColor: '#343a40',
    successColor: '#28a745',
    dangerColor: '#dc3545',
    warningColor: '#ffc107',
    infoColor: '#17a2b8',
    white: '#ffffff',
    black: '#000000',
    grey: {
      100: '#f8f9fa',
      200: '#e9ecef',
      300: '#dee2e6',
      400: '#ced4da',
      500: '#adb5bd',
      600: '#6c757d',
      700: '#495057',
      800: '#343a40',
      900: '#212529',
    },
  },
  
  fonts: {
    primary: '"Roboto", sans-serif',
    secondary: '"Montserrat", sans-serif',
  },
  
  fontSizes: {
    small: '0.875rem',
    regular: '1rem',
    medium: '1.2rem',
    large: '1.5rem',
    xlarge: '1.8rem',
    xxlarge: '2.2rem',
    xxxlarge: '2.5rem',
    mega: '3rem',
  },
  
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },
  
  lineHeights: {
    body: 1.6,
    heading: 1.3,
  },
  
  spaces: {
    xxsmall: '0.25rem',
    xsmall: '0.5rem',
    small: '0.75rem',
    regular: '1rem',
    medium: '1.5rem',
    large: '2rem',
    xlarge: '3rem',
    xxlarge: '4rem',
  },
  
  sizes: {
    container: '1200px',
  },
  
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    regular: '0 5px 15px rgba(0, 0, 0, 0.1)',
    large: '0 15px 30px rgba(0, 0, 0, 0.1)',
  },
  
  borders: {
    radius: {
      small: '4px',
      regular: '8px',
      large: '16px',
      circle: '50%',
    },
  },
  
  transitions: {
    main: 'all 0.3s ease',
    fast: 'all 0.2s ease',
    slow: 'all 0.5s ease',
  },
  
  breakpoints: {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',
  },
};

export default theme;
